
import React, { Fragment } from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import * as actions from 'store/actions';
import Pagination from 'react-bootstrap/Pagination';
import * as ConfigTypes from 'config/ConfigTypes';
import { createArray } from 'helpers/TypeHelper';
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MiniPagination.scss'

const MiniPagination = observer(
    class ClipItem extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                pages: [],
                active: { 1: true, current: 1 }
            }
        }

        getTotalPages = () => {
            const { totalPages, workTotalPages } = this.props.mediaObjects;
            if (this.props.workSearch) return workTotalPages;
            return totalPages;
        }

        updatePages = () => {
            const { currentPage, workCurrentPage } = this.props.mediaObjects;
            let totalPages = this.getTotalPages();
            let pages = createArray(totalPages);
            let curPage = currentPage;
            if (this.props.workSearch) curPage = workCurrentPage;
            if (pages) {
                this.setState({
                    pages: pages,
                    active: {
                        [curPage]: true,
                        current: curPage
                    }
                });
            }
        }

        onPageClick = (page) => () => {
            const { workKeyword, workFields, objectKeyword, objectFields } = this.props.mediaObjects;
            this.setState({ active: { [page]: true, current: page } });

            if (this.props.workSearch) {
                console.log("LOGS: MiniPagination searchWorks workCurrentPage", page);
                this.props.searchWorks({ fields: workFields, keyword: workKeyword, clickPage: page });
                this.props.updateMediaObjects({ workCurrentPage: page });
            }
            else {
                console.log("LOGS: MiniPagination searchObjects currentPage", page);
                this.props.searchObjects({ keyword: objectKeyword, fields: objectFields, clickPage: page });
                this.props.updateMediaObjects({ currentPage: page });
            }
        }

        onNextClick = () => {
            let totalPages = this.getTotalPages();
            if (this.state.active.current && this.state.active.current < totalPages) {
                let current = this.state.active.current + 1;
                this.onPageClick(current)();
            }
        }

        onPrevClick = () => {
            if (this.state.active.current && this.state.active.current > 1) {
                let current = this.state.active.current - 1;
                this.onPageClick(current)();
            }
        }

        onLastClick = () => {
            let totalPages = this.getTotalPages();
            if (totalPages) this.onPageClick(totalPages)();
        }

        showBetween = ({ item, i }) => {
            if (i == this.state.active.current - 1) {
                return (<Fragment key={`paginationItem${i}`}>
                    <Pagination.Item active={this.state.active[item]}
                        onClick={this.onPageClick(item)}>{item}</Pagination.Item>
                    <Pagination.Ellipsis />
                </Fragment>)
            }
            return <Pagination.Ellipsis />
        }

        showMore = ({ item, i }) => {
            let count = this.state.pages.length - ConfigTypes.SHOW_PAGES;
            if (i == (this.state.active.current - 1) && ((this.state.active.current) === count)) {
                return (<Fragment key={`paginationItem${i}`}>
                    <Pagination.Item active={this.state.active[item]}
                        onClick={this.onPageClick(item)}>{item}</Pagination.Item>
                </Fragment>)
            }

            if (i == this.state.active.current - 1) {
                return (<Fragment key={`paginationItem${i}`}>
                    <Pagination.Item active={this.state.active[item]}
                        onClick={this.onPageClick(item)}>{item}</Pagination.Item>
                    <Pagination.Ellipsis />
                </Fragment>)
            }
            return <span></span>
        }

        showAll = () => {
            return (
                <Pagination className="minipagination">
                    <Pagination.First onClick={this.onPageClick(1)} />
                    <Pagination.Prev onClick={this.onPrevClick} className="minipagination-btn" />
                    {this.state.pages.map((item, i) => {
                        if (i == 0) return (
                            <Pagination.Item active={this.state.active[item]} key={`paginationItem${i}`}
                                onClick={this.onPageClick(item)}>{item}</Pagination.Item>)
                        if (i == ConfigTypes.SHOW_PAGES) {
                            return this.showBetween({ item, i })
                        }
                        if (i > ConfigTypes.SHOW_PAGES
                            && i < (this.state.pages.length - ConfigTypes.SHOW_PAGES)) {
                            return this.showMore({ item, i });
                        }
                        return (<Pagination.Item active={this.state.active[item]} key={`paginationItem${i}`}
                            onClick={this.onPageClick(item)}>{item}</Pagination.Item>)
                    })}
                    <Pagination.Next onClick={this.onNextClick} />
                    <Pagination.Last onClick={this.onLastClick} />
                </Pagination>)
        }

        componentDidUpdate(prev) {
            const { totalPages, workTotalPages } = this.props.mediaObjects;
            if ((prev.mediaObjects.totalPages != totalPages)
                || (prev.mediaObjects.workTotalPages != workTotalPages)
            ) {
                this.updatePages();
            }
        }

        componentDidMount() {
            this.updatePages();
        }

        render() {
            if (this.props.showAll) return this.showAll()
            return (
                <div className="minipagination">
                    <div className="minipagination-container">
                        <div className="minipagination-icon-box" onClick={this.onPrevClick}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </div>
                        <div className="minipagination-icon-box" onClick={this.onNextClick}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </div>
                    </div>
                </div>
            )
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    searchObjects: (data) => dispatch(actions.searchObjects(data)),
    searchWorks: (data) => dispatch(actions.searchWorks(data)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(MiniPagination));

